// extracted by mini-css-extract-plugin
export default {"button":"rp-z","reviewSort":"sp-z"};